export default {"src":"/_next/static/media/due-overdue.d2105933.svg","height":513,"width":513};